import { useContext, useEffect, useState } from 'react';
import { GetCmsObjectsByType } from '../../CMSManagement/CMS_api';
import { CMS_OBJECT_TYPES, CMS_Statuses } from '../../CMS_Constants';
import Announcement from './Announcement';
import Styles from './AnnouncementsCollection.module.scss';
import { UserContext } from 'context/User/UserContext';

import { Widget } from '../../../Home/components/Widget/Widget';

const AnnouncementsCollection = props => {
	const [Announcements, setAnnouncements] = useState([]);
	const [AnnouncementComponents, setAnnouncementComponents] = useState([]);

	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user =
		contextUser.userInfo.impersonationProfile ??
		contextUser.userInfo.userProfile;

	useEffect(() => {
		GetCmsObjectsByType(CMS_OBJECT_TYPES.Announcement.name).then(
			response => {
				let filteredAnnouncements = response.data
					.filter(
						announcement =>
							new Date(announcement.StartDate).setHours(0, 0, 0) <
								new Date() &&
							new Date(announcement.EndDate).setHours(23, 0, 0) >
								new Date() &&
							announcement.Status === CMS_Statuses.Approved
					)
					.sort(function (a, b) {
						return new Date(b.CreateDate) - new Date(a.CreateDate);
					});

				setAnnouncements(filteredAnnouncements);
			}
		);
	}, []);

	useEffect(() => {
		let comps = Announcements.map(announcement => {
			//role based display.
			//if the current user or impersonated user is assigned one of the roles that the announcement is visible to
			//render the component, else dont
			let shouldDisplay = determineRoleBasedDisplay(announcement);
			if (shouldDisplay) {
				return (
					<Announcement
						createdOn={new Date(
							Date.parse(announcement.CreateDate)
						).toLocaleDateString()}
						header={
							announcement.Fields.find(
								field =>
									field.FieldDefinition.Label ===
									CMS_OBJECT_TYPES.Announcement.fields.Header
							).Value
						}
						content={
							announcement.Fields.find(
								field =>
									field.FieldDefinition.Label ===
									CMS_OBJECT_TYPES.Announcement.fields.Content
							).Value
						}
						key={announcement.ID}
					/>
				);
			} else {
				return null;
			}
		});

		if (comps.length === 0) {
			comps = null;
		}
		setAnnouncementComponents(comps);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [Announcements, user]);

	const determineRoleBasedDisplay = announcement => {
		const roleField = announcement.Fields.find(
			field =>
				field.FieldDefinition.Label ===
				CMS_OBJECT_TYPES.Announcement.fields.VisibleTo
		);
		const announcementRoles = roleField.Value.split(',');

		let matchingUserRoles = [];
		if (user.Roles) {
			matchingUserRoles = user.Roles.map(role => {
				let matchingAnnouncementRole = announcementRoles.find(
					annRole => annRole === role.ID.toString()
				);

				if (matchingAnnouncementRole !== undefined) {
					return matchingAnnouncementRole;
				} else {
					return undefined;
				}
			});
		}

		let matchCount = matchingUserRoles.filter(x => x !== undefined).length;
		//return true if there is at least 1 matching role between the current user and the announcement's Visible To role assignments
		//or if the announcementRoles included "All Users"

		return matchCount > 0 || announcementRoles.includes('All Users');
	};

	return (
		<>
			{AnnouncementComponents && (
				<Widget
					title='Announcements'
					subtitle='Announcements relevant to you.'
					className={Styles.cardContainer}
				>
					<div>{AnnouncementComponents}</div>
				</Widget>
			)}
		</>
	);
};

export default AnnouncementsCollection;
